import { localUrls } from "./urls.js";

// Lazy-loaded components for code splitting
const LoginPage = () =>
    import(/* webpackChunkName: "auth" */ "./components/LoginPage.vue");
const LogoutPage = () =>
    import(/* webpackChunkName: "auth" */ "./components/LogoutPage.vue");

export default [
    {
        path: localUrls.login,
        component: LoginPage,
        name: "login",
        props: true,
    },
    {
        path: localUrls.logout,
        component: LogoutPage,
        name: "logout",
    },
    // {
    //   path: localUrls.account,
    //   component: AccountPage,
    //   name: 'account'
    // },
    // {
    //   path: localUrls.accountCreate,
    //   component: AccountCreatePage,
    //   name: 'account-create'
    // }
];
